export default __webpack_public_path__ + "static/media/2.54723c94.webp";